const _getUserRole = () => {
  const storeUser = JSON.parse(localStorage.getItem('user'))
  if (!storeUser) {
    return null
  }
  const user = storeUser.user

  if (!user) {
    return null
  }
  return user.role
}

export const checkRole = (role) => {
  const userRole = _getUserRole()
  if (!userRole) {
    return false
  }
  return userRole === role
}

export const isAuth = () => {
  return !!JSON.parse(localStorage.getItem('user'))
}

export const permissions = {
  STORE_SHOPIFY_INTEGRATION: 'store-shopify-integration',
  STORE_JUMPSELLER_INTEGRATION: 'store-jumpseller-integration',
  STORE_API_ACCESS: 'store-api-access'
}
